module.exports = __webpack_public_path__ + "static/media/Jace.cbbefc27.png";